{
  "testRamp": {
    "layout": "Layout",
    "iterativeMode": "Iterativer Modus",
    "showCurvedLines": "Kurven anzeigen",
    "showAircraftImages": "Flugzeugbilder anzeigen",
    "datasetSize": "Datensatzgröße",
    "useSpaceQuality": "Raumqualitätsoptimierung verwenden",
    "qualityMetric": "Qualitätskennzahl",
    "optimizationLevel": "Optimierungsstufe",
    "safetyBufferMode": "Sicherheitspuffer-Modus",
    "priorityFirstSorting": "Sortierung nach Priorität",
    "showAreas": "Bereiche zeigen",
    "showObstacles": "Hindernisse anzeigen",
    "legends": {
      "obstacles": "Hindernisse",
      "noGoZones": "No-Go-Zonen"
    }
  }
}
